module.exports = __webpack_public_path__ + "9788f41e/img/link-icon.fa09ed66.svg";